import { createGlobalStyle } from 'styled-components';
import { cssVars } from '../../lib/styledTheme';

export const SelectGlobalStyles = createGlobalStyle`
  select {
    option {
      background-color: ${cssVars.bgColor};
      color: ${cssVars.textPrimary};
      padding: 10px 12px;
      font-size: 14px;
      font-family: inherit;
    }
    
    optgroup {
      background-color: ${cssVars.bgSecondary};
      color: ${cssVars.textSecondary};
      font-weight: 600;
      padding: 8px;
    }
  }
`;




